export default "__VITE_ASSET__Y27AXCph__"